<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-file-tree"
      inline
      class="ml-0 pb-10 px-5 py-4"
      :title="`Logs da importação #${importacao.id}`"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div style="float: right !important" class="mt-n9" v-bind="attrs" v-on="on">
            <v-btn
              id="importacao-dados-logs-tecnicos"
              icon
              color="black"
              :loading="loadingLogsTecnicos"
              v-bind="attrs"
              @click="baixarLogsTecnicos()"
              v-on="on"
            >
              <v-icon size="22">mdi-download-circle-outline</v-icon>
            </v-btn>
          </div>
        </template>
        Clique aqui para baixar os logs técnicos
      </v-tooltip>
      <v-divider class="my-4" />
      <span id="importacao-dados-logs-first-sec">
        <v-row>
          <v-col cols="6">
            <label class="d-block mb-1">Título da importação:</label>
            <v-label>{{ importacao.titulo }}</v-label>
          </v-col>
          <v-col cols="6">
            <label class="d-block mb-1">Empresa:</label>
            <v-label>{{ importacao.empresa }}</v-label>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <label class="d-block mb-1">Descrição:</label>
            <v-label>{{ importacao.descricao ? importacao.descricao : '-' }}</v-label>
          </v-col>
          <v-col cols="6">
            <label class="d-block mb-1">Arquivo:</label>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  id="importacao-dados-baixar-arquivo"
                  class="clickable-item"
                  style="display: inline !important"
                  v-bind="attrs"
                  @click="baixarArquivo()"
                  v-on="on"
                >
                  {{ importacao.arquivo }} ({{ importacao.encoding }})
                  <v-progress-circular v-if="loading" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
                </div>
              </template>
              Clique aqui para baixar o arquivo {{ importacao.arquivo }}
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <label class="d-block mb-1">Tipo de importação:</label>
            <v-label>{{ importacao.tipo }}</v-label>
          </v-col>
          <v-col v-if="importacao.data_registro" cols="6">
            <label class="d-block mb-1">Mês dos dados:</label>
            <v-label>
              {{ importacao.data_registro | formatToMonth }}
            </v-label>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <label class="d-block mb-1">Criado por:</label>
            <v-label>{{ importacao.usuario }} em {{ importacao.criado_em }}</v-label>
          </v-col>
          <v-col cols="6">
            <label class="d-block mb-1">Logs da importação:</label>
            <v-tooltip v-if="importacao.log_importacao_existe" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="importacao-dados-logs-valid"
                  color="gray"
                  outlined
                  small
                  :loading="loadingLogs"
                  v-bind="attrs"
                  @click="baixarLogs()"
                  v-on="on"
                >
                  <v-icon left>mdi-download-circle-outline</v-icon>
                  Baixar
                </v-btn>
              </template>
              Clique aqui para baixar os logs
            </v-tooltip>
            <v-label v-else>-</v-label>
          </v-col>
        </v-row>
      </span>
      <v-divider class="mb-2 mt-2" />
      <v-row v-if="importacao.status">
        <v-col cols="12">
          <import-status-card id="import-status-card" :status="importacao.status" :contadores="contadores" />
        </v-col>
      </v-row>
      <v-row v-if="importacao.status" id="import-status-tabela-contadores">
        <v-col cols="12">
          <tabela-contadores :contadores="contadores" />
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import ImportacoesDadosService from '@/services/ImportacoesDadosService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    components: {
      ImportStatusCard: () => import('@/components/dados/importacoes-dados/ImportStatusCard'),
      TabelaContadores: () => import('@/components/dados/importacoes-dados/TabelaContadores.vue')
    },
    mixins: [refreshDataMixins],
    data: () => ({
      importacao: {},
      loading: false,
      loadingLogs: false,
      loadingLogsTecnicos: false
    }),
    computed: {
      contadores() {
        return this.importacao && this.importacao.contadores ? JSON.parse(this.importacao.contadores) : null;
      }
    },
    async created() {
      await this.refreshData(this.getLogsImportacao);
    },

    methods: {
      getLogsImportacao() {
        if (!this.$route.params.id) {
          return;
        }

        ImportacoesDadosService.getLogsImportacao(this.$route.params.id).then((importacao) => {
          this.importacao = importacao;
        });
      },

      baixarArquivo() {
        this.loading = true;

        ImportacoesDadosService.baixarArquivo(this.importacao.arquivo_id)
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.importacao.arquivo);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            this.$toast.error(`Falha no download do arquivo ${this.importacao.arquivo}.`, '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      baixarLogs() {
        this.loadingLogs = true;

        ImportacoesDadosService.baixarLogs(this.importacao.id)
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `logs-importacao-${this.importacao.id}.zip`);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            this.$toast.error('Falha no download dos logs de importação.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loadingLogs = false));
      },

      baixarLogsTecnicos() {
        this.loadingLogsTecnicos = true;

        ImportacoesDadosService.baixarLogsTecnicos(this.importacao.id)
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `logs-tecnicos-importacao-${this.importacao.id}.log`);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            this.$toast.error('Falha no download dos logs técnicos.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loadingLogsTecnicos = false));
      }
    }
  };
</script>
